import React, { Component } from "react";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
  table1: {
    margin: "20px",
    width: 700,
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },

  boldCenterCell: {
    fontWeight: "bold",
    fontSize: 14,
    align: "center",
  },
});

class CdisbSummaryDetails extends Component {
  render() {
    const { classes } = this.props;
    let { t } = this.props;
    let report = this.props.report;

    return (
      <div>
        <div style={{ marginTop: 30, marginLeft: 20 }}>
          <Typography variant="headline">
            &nbsp;{t("fundingReportCdisb.label")}
          </Typography>
        </div>
        <table className={classes.table1}>
          <Paper elevation={6}>
            <tr>
              <td style={{ width: "120px" }}>
                {" "}
                <strong>&nbsp;{t("reportDate.label")}:</strong>
              </td>
              <td style={{ width: "330px" }}> {report.dateCreated}</td>
              <td style={{ width: "300px" }}>
                {" "}
                <strong>{t("createdBy.label")}:</strong> &nbsp;&nbsp;&nbsp;
                {report.userName}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>
                <strong>
                  {t("fundingFor.label")}:&nbsp;&nbsp;&nbsp;{" "}
                  {report.dateCreated}
                </strong>
              </td>
            </tr>
            <br />
            <tr>
              <td style={{ width: "350px" }}>
                <strong>&nbsp;{t("companyName.header")}</strong>
              </td>
              <td style={{ width: "200px" }}>
                <strong>{t("transit.header")}</strong>
              </td>
              <td style={{ width: "200px" }}>
                <strong>{t("account.header")}</strong>
              </td>
            </tr>
            <tr>
              <td>&nbsp;{report.companyName}</td>
              <td>{report.transit}</td>
              <td>{report.account}</td>
            </tr>
          </Paper>
        </table>
        <div style={{ marginTop: 20, marginLeft: 20 }}>
          <Typography variant="h6">
            &nbsp;{t("checkAccountSummary.label")}
          </Typography>
        </div>

        <table className={classes.table}>
          <Paper elevation={6}>
            <TableHead>
              <tr>
                <td style={{ width: "350px" }}>&nbsp;&nbsp;&nbsp;</td>
                <td style={{ width: "200px" }}>{t("items.label")}</td>
                <td style={{ width: "200px" }}>{t("amount.label")}</td>
              </tr>
            </TableHead>
            <TableBody>
              <tr>
                <td colSpan={3}>
                  <strong>{t("checks.label")}</strong>
                </td>
              </tr>
              <tr>
                <td>{t("totalPresented.label")}</td>
                <td>{report.numTotalDebits}</td>
                <td>{report.totalDebits}</td>
              </tr>
              {/*}
						<tr>
						  <td >Total Suspects</td>
						  <td >{report.numTotalDebitsExc}</td>
						  <td >{report.totalDebitsExc}</td>
						</tr>
	*/}
              <tr>
                <td>{t("totalReturned.label")}</td>
                <td>{report.numTotalDebitsRet}</td>
                <td>{report.totalDebitsRet}</td>
              </tr>
              <tr>
                <td>{t("totalAdj.label")}</td>
                <td>{report.numTotalDebitsAdj}</td>
                <td>{report.totalDebitsAdj}</td>
              </tr>
              <tr style={{ height: "20px" }}></tr>
              <tr>
                <td colSpan={2}>
                  <strong>{t("fundingReq.label")}</strong>
                </td>
                <td>
                  <strong>$&nbsp;{report.totalDebitsFunding}</strong>
                </td>
              </tr>
              <tr style={{ height: "20px" }}></tr>
              <tr>
                <td colSpan={3}>
                  <strong>{t("elecTrans.label")}</strong>
                </td>
              </tr>
              <tr>
                <td>{t("totalPresented.label")}</td>
                <td>{report.numTotalElectronic}</td>
                <td>{report.totalElectronic}</td>
              </tr>
              {/*}
						<tr>
						  <td >Total Suspects</td>
						  <td >{report.numTotalElectronicExc}</td>
						  <td >{report.totalElectronicExc}</td>
						</tr>
*/}
              <tr>
                <td>{t("totalReturned.label")}</td>
                <td>{report.numTotalElectronicRet}</td>
                <td>{report.totalElectronicRet}</td>
              </tr>
              <tr style={{ height: "20px" }}></tr>
              <tr>
                <td colSpan={2}>
                  <strong>{t("fundingRequirement.label")}</strong>
                </td>
                <td>
                  <strong>$&nbsp;{report.totalElectronicFunding}</strong>
                </td>
              </tr>
              <tr style={{ height: "20px" }}></tr>
              <tr>
                <td colSpan={2}>
                  <strong>
                    {t("fundingReqAs.label")} {report.dateCreated}
                  </strong>
                </td>
                <td>
                  <strong>$&nbsp;{report.totalFunding}</strong>
                </td>
              </tr>
            </TableBody>
          </Paper>
        </table>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(CdisbSummaryDetails));
